export default __webpack_public_path__ + "static/media/license-enterprise-bg.c4a8f6ed.svg";